import React from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../Login';
import '../../styles/AuthPages.css';

const LoginPage = ({ onLogin }) => {
  const navigate = useNavigate();

  return (
    <div className="auth-page">
      <div className="auth-container">
        <Login 
          onLogin={onLogin}
          onRegisterClick={() => navigate('/register')}
          isStandalone={true}
        />
      </div>
    </div>
  );
};

export default LoginPage; 